import React, { Fragment, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { Alert } from "reactstrap";

const AlertSuccess = ({ showAlertSuccess, setShowAlertSuccess, textHeader, textBody }) => {
  const progressBarRef = useRef(null);
  
  useEffect(() => {
    if (showAlertSuccess) {
      const progressBar = progressBarRef.current;
      if (progressBar) {
        progressBar.style.width = '0%';
        setTimeout(() => {
          progressBar.style.width = '100%';
        }, 10);
        
        const timer = setTimeout(() => {
          setShowAlertSuccess(false);
        }, 5000);
        
        return () => clearTimeout(timer);
      }
    }
  }, [showAlertSuccess, setShowAlertSuccess]);

  if (!showAlertSuccess) return null;
  
  return (
    <Fragment>
      <div className="floating-alert-container">
        <Alert
          className="custom-alert"
          isOpen={showAlertSuccess}
          toggle={() => setShowAlertSuccess(false)}
        >
          <div className="alert-content">
            <h5 className="alert-header">
              <i className="fa fa-check-circle mx-2" />
              {textHeader}
            </h5>
            <div className="alert-body" dangerouslySetInnerHTML={{ __html: textBody }} />
            <div 
              ref={progressBarRef}
              className="alert-progress-bar"
            />
          </div>
        </Alert>
      </div>
    </Fragment>
  );
};

AlertSuccess.propTypes = {
  showAlertSuccess: PropTypes.bool,
  setShowAlertSuccess: PropTypes.func,
  textHeader: PropTypes.string,
  textBody: PropTypes.string,
};

export default AlertSuccess;
